import { format } from "date-fns";
import csLocale from "date-fns/locale/cs";
import { type FC } from "react";
import { BodyTextM } from "../../../components";
import { useTypedTranslation } from "../../../hooks/useTypedTranslation";
import { INFLATION_PERCENT } from "../InflationStepper.helpers";
import * as Styled from "../InflationStepper.styled";
import { InflationResult, InflationStepperProps } from "../InflationStepper.types";

type RecapProps = InflationStepperProps & {
    formResult: InflationResult | null;
};

export const Recap: FC<RecapProps> = ({ formResult, inflationData, setPageIndex }) => {
    const { t } = useTypedTranslation();
    const inflationAccepted = formResult?.inflation === true;
    const gioAccepted = formResult?.gio === true;
    const showGio = formResult?.gio !== undefined;
    const showInflation = formResult?.inflation !== undefined;

    const percent = INFLATION_PERCENT;
    const date = inflationData?.anniversaryDate
        ? format(new Date(inflationData.anniversaryDate), "d. M. yyyy", { locale: csLocale })
        : t("global.NA");

    const inflationKey = inflationAccepted ? "inflationStepper.recapAccept" : "inflationStepper.recapDecline";
    const gioKey = gioAccepted ? "inflationStepper.recapGioAccept" : "inflationStepper.recapGioDecline";

    return (
        <>
            <Styled.Heading>{t("global.changesOverview")}</Styled.Heading>

            {showInflation && (
                <Styled.Wrapper>
                    <BodyTextM>{t(inflationKey, { percent, date })}</BodyTextM>
                </Styled.Wrapper>
            )}

            {showGio && (
                <Styled.Wrapper>
                    <BodyTextM>{t(gioKey)}</BodyTextM>
                </Styled.Wrapper>
            )}

            <Styled.ContinueButtonWrapper>
                <Styled.ContinueButton
                    onClick={() => {
                        setPageIndex?.(2);
                    }}
                >
                    {t("inflationStepper.continue")}
                </Styled.ContinueButton>
            </Styled.ContinueButtonWrapper>
        </>
    );
};
